import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";

export const ShowHideTable = ({
  showTable: externalShowTable,
  setShowTable: externalSetShowTable,
}) => {
  const [internalShow, setInternalShow, isPDFMode] = usePDFShowHide(false);

  // Determine which state to use - in PDF mode, always show
  const showTable = isPDFMode
    ? true
    : externalShowTable !== undefined
    ? externalShowTable
    : internalShow;
  const setShowTable = externalSetShowTable || setInternalShow;

  return (
    <img
      src={showTable ? hideIcon : showIcon}
      alt={showTable ? "Hide Icon" : "Show Icon"}
      width={25}
      height={25}
      onClick={() => !isPDFMode && setShowTable(!showTable)}
      className="show-hide-table-icon"
      style={{
        opacity: isPDFMode ? 0.5 : 1,
        cursor: isPDFMode ? "default" : "pointer",
      }}
    />
  );
};
